import { useEffect, useState } from "react";
import { useAuth } from "../providers/AuthContext";
import { getAgreementByPublicId } from "../api/Agreement";

/**
 * Whether the SCO user pages are switched on for the agreement (PBI #377). Off until the
 * agreement says otherwise: a failed fetch or an older API without the flag counts as off,
 * and the API refuses the SCO endpoints for such an agreement anyway.
 *
 * @param {string} agreementPublicId - The agreement in the current route
 * @returns {{ enabled: boolean, loaded: boolean }}
 */
const useScoFormsEnabled = (agreementPublicId) => {
  const { getAccessToken } = useAuth();
  const [state, setState] = useState({ enabled: false, loaded: false });

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      let enabled = false;
      try {
        const accessToken = await getAccessToken();
        const agreement = await getAgreementByPublicId(agreementPublicId, accessToken);
        enabled = agreement?.scoFormsEnabled === true;
      } catch {
        // Unreachable agreement: the pages stay off.
      }
      if (!cancelled) setState({ enabled, loaded: true });
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [agreementPublicId]);

  return state;
};

export default useScoFormsEnabled;
